// extracted by mini-css-extract-plugin
export var bodyRow = "_d2-d";
export var cardColumns = "_d2-e";
export var ellipsesOverflow = "_d2-2";
export var flatBottomCorners = "_d2-3";
export var flatTopCorners = "_d2-4";
export var headerActionsDropdown = "_d2-f";
export var headerBottomRow = "_d2-c";
export var headerTopRow = "_d2-b";
export var orderDetailsWrapper = "_d2-0";
export var orderInfoContainer = "_d2-1";
export var productDetails = "_d2-9";
export var productImage = "_d2-5";
export var responsiveTable = "_d2-8";
export var shipmentContainer = "_d2-a";
export var tableBottomLeft = "_d2-6";
export var tableBottomRight = "_d2-7";
export var trackingLink = "_d2-g";